var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscoverColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discover-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "card_bg-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H22C23.1046 0 24 0.89543 24 2V14C24 15.1046 23.1046 16 22 16H2C0.89543 16 0 15.1046 0 14V2C0 0.89543 0.89543 0 2 0ZM23 2C23 1.44772 22.5523 1 22 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H22C22.5523 15 23 14.5523 23 14V2Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "discover"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M23 8.86V14C23 14.5523 22.5523 15 22 15H6C17 13.11 23 8.86 23 8.86Z",
    fill: "#EE7623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.32H2.91C3.60663 5.26962 4.25629 5.67414 4.51844 6.32153C4.78059 6.96892 4.59542 7.71149 4.06 8.16C3.73348 8.41639 3.32443 8.54444 2.91 8.52H2V5.32ZM2.79 8C3.10288 8.02804 3.41361 7.92687 3.65 7.72C3.87143 7.51345 3.99497 7.22276 3.99 6.92C3.99625 6.61699 3.87249 6.3258 3.65 6.12C3.40936 5.92234 3.09984 5.82876 2.79 5.86H2.63V8H2.79Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.92999,
    y: 5.32,
    width: 0.63,
    height: 3.21,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M7.07999 6.55C6.70999 6.41 6.59999 6.32 6.59999 6.14C6.59999 5.96 6.78999 5.79 7.05999 5.79C7.26183 5.78997 7.45146 5.88664 7.56999 6.05L7.89999 5.62C7.62751 5.37227 7.26785 5.24279 6.89999 5.26C6.3775 5.25833 5.94179 5.65918 5.89999 6.18C5.89999 6.62 6.09999 6.85 6.68999 7.06C6.93999 7.15 7.05999 7.21 7.12999 7.24C7.24274 7.3164 7.31019 7.4438 7.30999 7.58C7.29488 7.80924 7.10952 7.99029 6.87999 8C6.58552 8.00457 6.31562 7.83638 6.18999 7.57L5.78999 8C6.0245 8.38577 6.44879 8.61512 6.89999 8.6C7.19099 8.6297 7.4804 8.53049 7.69199 8.32852C7.90358 8.12655 8.01613 7.84206 7.99999 7.55C7.99999 7 7.79999 6.81 7.07999 6.55Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M8.20999 6.92C8.20451 7.36896 8.38113 7.801 8.69956 8.11755C9.01799 8.43409 9.45107 8.60815 9.89999 8.6C10.1712 8.59797 10.4382 8.53292 10.68 8.41V7.67C10.4886 7.88208 10.2157 8.00217 9.92999 8C9.6329 8.02546 9.33995 7.91701 9.13104 7.70424C8.92214 7.49147 8.81909 7.19658 8.84999 6.9C8.84464 6.61715 8.95258 6.34389 9.14979 6.14105C9.347 5.93821 9.6171 5.82262 9.89999 5.82C10.2009 5.81652 10.4874 5.94874 10.68 6.18V5.44C10.4446 5.30875 10.1795 5.2399 9.90999 5.24C9.46178 5.23734 9.03086 5.41285 8.71205 5.72791C8.39323 6.04297 8.21264 6.47178 8.20999 6.92Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M15.65 7.47L14.79 5.32H14.11L15.47 8.61H15.81L17.19 5.32H16.52L15.65 7.47Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M17.48 8.53H19.25V7.98H18.1V7.12H19.21V6.57H18.1V5.86H19.25V5.32H17.48V8.53Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.73 6.26C21.7616 6.70942 21.4448 7.10861 21 7.18L22 8.52H21.24L20.37 7.23H20.3V8.52H19.67V5.32H20.59C21.32 5.32 21.73 5.66 21.73 6.26ZM20.3 6.79H20.48C20.87 6.79 21.08 6.59 21.08 6.27C21.08 5.95 20.87 5.79 20.49 5.79H20.3V6.79Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M14.3 6.92C14.304 7.61253 13.89 8.23912 13.2513 8.50695C12.6127 8.77478 11.8756 8.63095 11.3844 8.14269C10.8933 7.65443 10.7451 6.91815 11.0092 6.27794C11.2733 5.63773 11.8975 5.22001 12.59 5.22C13.5283 5.22539 14.2891 5.98177 14.3 6.92Z",
    fill: "#EE7623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.06 5.38C22.0604 5.41507 22.0347 5.44499 22 5.45L22.09 5.58H22.01L21.92 5.46V5.58H21.85V5.29H21.95C22.06 5.29 22.06 5.32 22.06 5.38ZM21.94 5.35V5.45L22 5.41L21.99 5.35H21.94Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.76 5.43C21.7599 5.29574 21.8658 5.18537 22 5.18C22.1341 5.18537 22.2401 5.29574 22.24 5.43C22.24 5.56255 22.1325 5.67 22 5.67C21.8674 5.67 21.76 5.56255 21.76 5.43ZM22 5.64C22.0504 5.64159 22.0985 5.61935 22.13 5.58H22.1C22.1486 5.54381 22.1809 5.4899 22.19 5.43C22.19 5.36212 22.1538 5.2994 22.095 5.26546C22.0362 5.23152 21.9638 5.23152 21.905 5.26546C21.8462 5.2994 21.81 5.36212 21.81 5.43C21.8073 5.48306 21.8258 5.53502 21.8614 5.57442C21.8971 5.61382 21.9469 5.63741 22 5.64Z",
    fill: "#231F20"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverColor);
export default __webpack_public_path__ + "static/media/discover-color.5c9a9429.svg";
export { ForwardRef as ReactComponent };